export const APP_CONSTANTS = {
  API_URL: "https://app.faramohtava.com/api/v1"
};
